// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface TransformationsOptions {
    width?: number | string;
    quality?: "best" | "good" | "eco" | "low";
}

/**
 *
 * @param url
 * @param baseCloudinaryUrl
 * @param transformations
 */
export const getCloudinaryUrl = (
    url?: string,
    baseCloudinaryUrl?: string,
    transformations?: TransformationsOptions,
): string => {
    let options = "/f_auto";

    // if the url doesn't Cloudinary or empty, send back
    if (!url || !baseCloudinaryUrl || !url.startsWith(baseCloudinaryUrl)) {
        return url || "";
    }

    let imageUrlPath = url.replace(baseCloudinaryUrl, "");

    // Strip "image/upload/" prefix if present
    imageUrlPath = imageUrlPath.replace(/^image\/upload\//, "");

    // Strip any existing transformation segment left over from a previous
    // call to this function (e.g. "f_auto,w_auto/", "f_auto,w_100,q_auto:good/").
    // Cloudinary transformation segments are a comma-separated list of
    // param_value pairs, optionally with a leading fl_/f_/w_/q_ etc.
    imageUrlPath = imageUrlPath.replace(/^([a-z]+_[^/,]+(?:,[a-z]+_[^/,]+)*)\//i, "");

    // If this is a svg file, we need to remove f_auto option which will
    // rasterizer the vector graphic and instead use fl_sanitize to prevent
    // automatically downloading the svg instead of displaying correctly as img src.
    if (url.endsWith(".svg")) {
        options = "fl_sanitize/";
    } else {
        const rawWidth = `${transformations?.width || "auto"}`.replace("px", "");
        // Percentage widths aren't valid Cloudinary w_ values, so fall back to "auto"
        const width = rawWidth.endsWith("%") ? "auto" : rawWidth;
        options = `f_auto,w_${width},q_auto:${transformations?.quality || "good"}/`;
    }

    return `${baseCloudinaryUrl}${options}${imageUrlPath}`;
};
